import _typeof from "@babel/runtime/helpers/esm/typeof";
// 操作dom的工具方法
export var spmDataKey = 'data-aspm';
export var spmDPosMarkAttr = 'data-aspm-click';
export var spmExpoAttr = 'data-aspm-expo';
export var spmExtParamAttr = 'data-aspm-param';
//可视化埋点点位标注
export var spmVisualAttr = 'data-aspm-visual';

// 以a开头的元素也会被命中，例如：article
// const spmDPosTagPattern = /^a|area$/i;
var spmDPosTags = ['A', 'AREA'];
export function strToObj(str) {
  var spliter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '^';
  if (typeof str !== 'string') {
    return null;
  }
  var strList = str.split(spliter);
  if (str.indexOf('=') === -1) {
    return strList;
  }
  var strLen = strList.length;
  var strItem;
  var result = {};
  for (var strIdx = 0; strIdx < strLen; strIdx++) {
    strItem = strList[strIdx];
    if (strItem) {
      var splitBitIndex = strItem.indexOf('=');
      if (splitBitIndex > 0) {
        var key = strItem.substring(0, splitBitIndex);
        var value = strItem.substr(splitBitIndex + 1) || '';
        result[key] = value;
      }
    }
  }
  return result || {};
}

// 将dom转化为Array
export function nodeListToArray(nodes) {
  var arr;
  var length;
  try {
    arr = [].slice.call(nodes);
    return arr;
  } catch (err) {
    arr = [];
    length = nodes.length;
    for (var i = 0; i < length; i++) {
      arr.push(nodes[i]);
    }
    return arr;
  }
}
// 当前页面是否加载完成
export function isLoaded() {
  if (window.performance && window.performance.timing) {
    // 现代浏览器
    return !!window.performance.timing.loadEventEnd;
  } else {
    var _window, _window$document;
    // 老式浏览器
    return ((_window = window) === null || _window === void 0 ? void 0 : (_window$document = _window.document) === null || _window$document === void 0 ? void 0 : _window$document.readyState) === 'complete';
  }
}
// 获取dom上面的属性
export function getAttr(element, attrName) {
  return element && element.getAttribute ? element.getAttribute(attrName) || '' : '';
}

// 判断是不是一个dom
export function isDom(dom) {
  return dom !== null && _typeof(dom) === 'object' && dom.nodeType === 1;
}

// 是否非body以及document的dom
export function isViewDom(dom) {
  if (!dom || !isDom(dom) || dom === document.body || dom === document.documentElement) {
    return false;
  }
  return true;
}

/**
 * 获取页面spm元数据
 * 元数据包括：
 * 1. spm a位，在meta标签里 name 为 data-aspm 的 content 中
 * 2. 页面bizType，在meta标签里 name 为 data-bizType 的 content 中
 */
export function getMetaSpm(metas, container) {
  var containerDom = container || document;
  var metaList = nodeListToArray(metas || containerDom.getElementsByTagName('meta'));
  var len = metaList.length;
  var metaItem;
  var name;
  var content;
  var bizType;
  var spmAPos;
  for (var i = 0; i < len; i++) {
    metaItem = metaList[i];
    name = getAttr(metaItem, 'name');
    content = getAttr(metaItem, 'content');
    switch (name) {
      case spmDataKey:
        spmAPos = content;
        break;
      case 'data-bizType':
        bizType = content;
        break;
      default:
        break;
    }
    if (spmAPos && bizType) {
      break;
    }
  }
  var ret = {};
  if (spmAPos) {
    ret.spmAPos = spmAPos;
  }
  if (bizType) {
    ret.bizType = bizType;
  }
  return ret;
}

/**
 * 获取spm b位数据
 * b位数据为 body 元素 data-aspm 的值
 */
export function getSpmBPos() {
  var spmBPos = getAttr(document.body, spmDataKey);
  return spmBPos;
}

/**
 * 获取spm c位数据
 * c位数据挂载在dom上，属性 data-aspm 的值
 */
export function getSpmCPos(el) {
  var dom = el;
  if (!isViewDom(dom)) {
    return '';
  }
  var spmCPos = '';
  while (dom && dom !== document.body) {
    spmCPos = getAttr(dom, spmDataKey);
    if (spmCPos) {
      break;
    }
    dom = dom.parentNode;
  }
  return spmCPos;
}

/**
 * 判断是否为spmD的dom，如果是 返回这个 dom 对象，如果不是，返回null
 */
export function getDPosDom(el) {
  var dom = el;
  if (!isViewDom(dom)) {
    return 'null';
  }
  do {
    if (spmDPosTags.indexOf(dom.tagName) !== -1 || dom.hasAttribute(spmDPosMarkAttr)) {
      return dom;
    }
  } while ((dom = dom.parentNode) && dom && dom.tagName && dom.tagName !== 'BODY' && dom !== document.body && !getAttr(dom, spmDataKey));
  return null;
}

/**
 * 获取spm d位数据
 * 1. 如果dom上有 data-aspm-click 属性，则 d 位信息为其属性值
 * 2. 默认情况下会对 a, area 获取其在父元素中的索引作为其 d 位信息
 */
export function getSpmDPos(el) {
  var dom = el;
  if (!isViewDom(dom)) {
    return '';
  }
  if (!(spmDPosTags.indexOf(dom.tagName) !== -1 || dom.hasAttribute(spmDPosMarkAttr))) {
    dom = getDPosDom(dom);
  }
  if (!dom) {
    return '';
  }
  var spmDPos = getAttr(dom, spmDPosMarkAttr);
  var tagName = dom.tagName;
  if (typeof spmDPos === 'string' || spmDPosTags.indexOf(tagName) !== -1) {
    if (!spmDPos) {
      var idx = 0;
      var rollDom = dom;
      do {
        if (isDom(rollDom)) {
          if (tagName === rollDom.tagName) {
            idx++;
          }
        }
        rollDom = rollDom.previousSibling;
      } while (rollDom);
      spmDPos = idx;
    }
  }
  return "".concat(spmDPos);
}

// 获取dom上面的 data-aspm-param 的值并做解析
export function getDomParam(dom) {
  var paramStr = dom && dom.getAttribute ? dom.getAttribute('data-aspm-param') : '';
  return strToObj(paramStr) || {};
}
// 获取dom上面的 data-aspm-config 的值并做解析
export function getDomConfig(dom) {
  var paramStr = dom && dom.getAttribute ? dom.getAttribute('data-aspm-config') : '';
  return strToObj(paramStr) || {};
}
export function getContentParam(dom) {
  if (!dom || !dom.hasAttribute) {
    return {};
  }
  var isContentPoint = dom.hasAttribute('data-aspm-content');
  if (!isContentPoint) return {};
  var newChinfo = dom.getAttribute('data-anewChinfo') || '';
  var newScm = dom.getAttribute('data-new-ascm') || '';
  var scm = dom.getAttribute('data-ascm') || newScm;
  return {
    param5: "newChinfo=".concat(newChinfo, "^scm=").concat(scm),
    newScm: newScm
  };
}

/**
 * @deprecated
 */
export function getMetaPageName() {
  var _window2;
  var metaKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'pagename';
  var container = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.document;
  var metaList = nodeListToArray(container.getElementsByTagName('meta'));
  var metaSpmb = '';
  for (var i = 0; i < metaList.length; i++) {
    var metaItem = metaList[i];
    var name = getAttr(metaItem, 'name');
    var content = getAttr(metaItem, 'content');
    if (!content || !name) {
      continue;
    }
    if (name === metaKey) {
      metaSpmb = content;
      break;
    }
  }
  return metaSpmb;
}

/**
 * 获取某个元素在视图中显示的比例
 * antd mobile modal 会包一个高度为0的div 导致计算结果为NaN
 * @param element
 * @param clientRect
 * @returns {number}
 */
export function visibleProportion(element, clientRect) {
  var rect = clientRect || element.getBoundingClientRect();
  var clientHeight = document.documentElement.clientHeight;
  var top = Math.min(clientHeight, Math.max(rect.top, 0));
  var bottom = Math.max(0, Math.min(rect.top + rect.height, clientHeight));
  return (bottom - top) / rect.height || 1;
}
export function getCssSelector(dom) {
  if (!dom || dom.nodeType !== 1 || dom.tagName === 'BODY' || dom.tagName === 'HTML') {
    return '';
  }
  if (typeof dom.getAttribute === 'function' && dom.getAttribute('id')) {
    return "#".concat(dom.getAttribute('id'));
  }
  if (typeof dom.className === 'string' && dom.className) {
    return ".".concat(dom.className.split(/\s+/).join(' .'));
  }
  return '';
}